import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F4F1EE] px-6">
      <div className="w-full max-w-md text-center" data-testid="payment-cancel">
        <h1 className="font-display text-4xl text-[#1A362D]">Checkout canceled</h1>
        <p className="text-[#5C6B64] mt-3">No worries — you weren't charged. Come back when you're ready.</p>
        <div className="mt-8 flex justify-center gap-3">
          <Button asChild variant="outline" className="rounded-full h-12"><Link to="/dashboard" data-testid="cancel-back-dashboard">Back to dashboard</Link></Button>
          <Button asChild className="rounded-full h-12 bg-[#1A362D] hover:bg-[#2C4A40] text-white"><Link to="/upgrade" data-testid="cancel-back-upgrade">Back to plans</Link></Button>
        </div>
      </div>
    </div>
  );
}
